import { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { CentralMappingCategory } from 'lumen/models';
import CentralMappingMappingEntry from 'lumen/models/central-mapping/mapping-entry';

// True = Yes
// False = No
// Null = Unmapped
// Note: don't define as `@attr('boolean')` otherwise Ember Data will convert `null` values to `false`.
export type BarBased = boolean | null;

// 'gross' | 'net' | 'no' = real values, null = Unmapped.
// Note: keep the bare `@attr()` so Ember Data preserves `null` instead of coercing it.
export type Commissionable = 'gross' | 'net' | 'no' | null;

export default class CentralMappingMappingEntryMarketSegment extends CentralMappingMappingEntry {
  // @ts-expect-error: Class inheritance
  [Type] = 'central-mapping/mapping-entry-market-segment' as const;

  // The category chosen by backends auto-mapping algorithm. Can not be adjusted by the user.

  @belongsTo('central-mapping/category', { async: false, inverse: null })
  declare autoCategory: CentralMappingCategory | null;

  @attr() declare autoBarBased: BarBased;
  @attr() declare autoCommissionable: Commissionable;
  @attr() declare userBarBased: BarBased;

  @attr() declare userCommissionable: Commissionable;

  get barBased(): BarBased {
    const { userBarBased, autoBarBased } = this;

    return userBarBased ?? autoBarBased;
  }

  get category(): CentralMappingCategory | null {
    const { userCategory, autoCategory } = this;

    return userCategory ?? autoCategory;
  }

  get commissionable(): Commissionable {
    const { userCommissionable, autoCommissionable } = this;

    return userCommissionable ?? autoCommissionable;
  }

  get isAutomapped(): boolean {
    return Boolean(!this.userCategory && this.autoCategory);
  }

  get isBarBasedAutomapped(): boolean {
    return Boolean(!this.userBarBased && this.autoBarBased);
  }

  get isCommissionableAutomapped(): boolean {
    return Boolean(!this.userCommissionable && this.autoCommissionable);
  }
}
